import { render } from "./header.html?vue&type=template&id=713eccf0&scoped=true&ts=true"
import script from "./header.ts?vue&type=script&lang=ts"
export * from "./header.ts?vue&type=script&lang=ts"

import "./header.scss?vue&type=style&index=0&id=713eccf0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/legacy_vue_store/legacy_vue_store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713eccf0"]])

export default __exports__